// extracted by mini-css-extract-plugin
export default {"Icon":"OiFQ8ulJ","IconContainer":"HAg_IJsi","ButtonPlaceholder":"QqOTmRF2","ButtonSkeleton":"LJSYW2jq","IconPlaceholder":"HTuMmum8"};